// test524
(524 && 0);
